import Crud from '../views/Video/Crud'
import Add from '../views/Video/Add'

let routes = {
    path: '/videos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/videos',
            name: 'list-videos',
            component: Crud,
            meta: {
                pageTitle: "Lista de Videos",
                breadcrumb: [
                    {
                        text: "videos",
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/videos/add',
            name: 'NewVideo',
            component: Add,
            meta: {
                pageTitle: 'Criação de Videos',
                breadcrumb: [
                    {
                        text: 'Videos',
                        active: false,
                        to: '/videos',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/videos/edit/:id?',
            name: 'ViewVideo',
            component: Add,
            meta: {
                pageTitle: "Editar Video",
                breadcrumb: [
                    {
                        text: "videos",
                        active: false,
                        to: '/videos',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
    ]
};


export default routes
